import { render } from "./EmployeeLocationWidget.vue?vue&type=template&id=f094c426&scoped=true"
import script from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"

import "./EmployeeLocationWidget.vue?vue&type=style&index=0&id=f094c426&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f094c426"]])

export default __exports__